import E from "lodash";
import a from "react";
import k from "classnames";
import { u as $ } from "./DarkModeProvider-xoZXm3ct.es.js";
import { u as v } from "./ThemeProvider--i7ESlT5.es.js";
import "mintel-tokens/dist/tokens.custom-properties.css";
import './index6.css';const L = "#026fd9", B = "#89c3fe", H = "Text-default-module__inline___WddVn", A = "Text-default-module__h1___jkmLO", D = "Text-default-module__dark_bg___E2Eai", P = "Text-default-module__responsive___LN4yQ", q = "Text-default-module__h2___DLlzs", w = "Text-default-module__h3___QYapq", S = "Text-default-module__h4___YRv9e", z = "Text-default-module__h5___9UlNb", M = "Text-default-module__h6___OipDY", O = "Text-default-module__body___0z6QJ", W = "Text-default-module__body2___LU0sW", Y = "Text-default-module__body3___B6UwB", j = "Text-default-module__button___qQBof", I = "Text-default-module__link___NjNvl", Q = "Text-default-module__breadcrumb___nCqq9", V = "Text-default-module__legal___8lF-F", F = "Text-default-module__ban1___PrYAE", G = "Text-default-module__ban2___WivAh", R = "Text-default-module__underline___qiIgt", c = {
  lightLinkColor: L,
  darkLinkColor: B,
  "one-line-truncation": "Text-default-module__one-line-truncation___wuXaq",
  inline: H,
  h1: A,
  dark_bg: D,
  responsive: P,
  h2: q,
  h3: w,
  h4: S,
  h5: z,
  h6: M,
  body: O,
  body2: W,
  body3: Y,
  button: j,
  link: I,
  breadcrumb: Q,
  legal: V,
  ban1: F,
  ban2: G,
  "data-header": "Text-default-module__data-header___rMupp",
  "data-cell": "Text-default-module__data-cell___03wwl",
  "data-annotation": "Text-default-module__data-annotation___pMOmv",
  "data-pagination": "Text-default-module__data-pagination___1KZmQ",
  underline: R
}, U = "#0050dc", Z = "#00e0ff", J = "Text-compere-module__inline___hWyD9", K = "Text-compere-module__h1___tR2Cx", X = "Text-compere-module__dark_bg___ynZjq", p = "Text-compere-module__responsive___zRz1q", ee = "Text-compere-module__h2___Hr-Wi", ae = "Text-compere-module__h3___8WINc", te = "Text-compere-module__h4___yd6Zw", ne = "Text-compere-module__h5___lFzZT", le = "Text-compere-module__h6___5kB9t", _e = "Text-compere-module__body___AHJ4B", me = "Text-compere-module__body2___GfoLv", oe = "Text-compere-module__body3___3VoTt", ie = "Text-compere-module__button___6IowA", de = "Text-compere-module__link___n57SY", ce = "Text-compere-module__breadcrumb___mXTaG", ue = "Text-compere-module__legal___gfUrs", re = "Text-compere-module__ban1___4v9nD", se = "Text-compere-module__ban2___EsFug", ge = "Text-compere-module__underline___S2TVV", Ne = {
  lightLinkColor: U,
  darkLinkColor: Z,
  "one-line-truncation": "Text-compere-module__one-line-truncation___uhtvG",
  inline: J,
  h1: K,
  dark_bg: X,
  responsive: p,
  h2: ee,
  h3: ae,
  h4: te,
  h5: ne,
  h6: le,
  body: _e,
  body2: me,
  body3: oe,
  button: ie,
  link: de,
  breadcrumb: ce,
  legal: ue,
  ban1: re,
  ban2: se,
  "data-header": "Text-compere-module__data-header___pupVJ",
  "data-cell": "Text-compere-module__data-cell___EwK2x",
  "data-annotation": "Text-compere-module__data-annotation___g-e8d",
  "data-pagination": "Text-compere-module__data-pagination___B4OIl",
  underline: ge
}, be = {
  default: c,
  compere: Ne
}, t = ({
  mruiClassName: e,
  className: n = "",
  darkBg: u = !1,
  oneLineTruncate: r = !1,
  children: m,
  tagName: l,
  responsive: s = !1,
  inline: g = !1,
  color: N,
  ariaHidden: b = void 0,
  underlineLinks: h = !1,
  ...o
}) => {
  const T = $(), x = v(), _ = E.get(be, x, c), i = {
    className: k(_[e], n, {
      [_.dark_bg]: u || T,
      [_["one-line-truncation"]]: r,
      [_.responsive]: s,
      [_.inline]: g,
      [_.underline]: h
    }),
    style: { color: N },
    "aria-hidden": b
  };
  if (l === "h1" || l === "h2" || l === "h3" || l === "h4" || l === "h5" || l === "h6") {
    const d = l, y = o;
    return /* @__PURE__ */ a.createElement(d, { ...i, ...y }, m);
  }
  if (l === "label") {
    const d = o;
    return (
      // eslint-disable-next-line jsx-a11y/label-has-associated-control
      /* @__PURE__ */ a.createElement("label", { ...i, ...d }, m)
    );
  }
  const f = l, C = o;
  return /* @__PURE__ */ a.createElement(f, { ...i, ...C }, m);
}, he = (e) => /* @__PURE__ */ a.createElement(
  t,
  {
    ...e,
    mruiClassName: "h1",
    tagName: e.tagName ?? "h1",
    inline: !e.tagName
  }
), Te = (e) => /* @__PURE__ */ a.createElement(
  t,
  {
    ...e,
    mruiClassName: "h2",
    tagName: e.tagName ?? "h2",
    inline: !e.tagName
  }
), xe = (e) => /* @__PURE__ */ a.createElement(
  t,
  {
    ...e,
    mruiClassName: "h3",
    tagName: e.tagName ?? "h3",
    inline: !e.tagName
  }
), fe = (e) => /* @__PURE__ */ a.createElement(
  t,
  {
    ...e,
    mruiClassName: "h4",
    tagName: e.tagName ?? "h4",
    inline: !e.tagName
  }
), Ce = (e) => /* @__PURE__ */ a.createElement(
  t,
  {
    ...e,
    mruiClassName: "h5",
    tagName: e.tagName ?? "h5",
    inline: !e.tagName
  }
), ye = (e) => /* @__PURE__ */ a.createElement(
  t,
  {
    ...e,
    mruiClassName: "h6",
    tagName: e.tagName ?? "h6",
    inline: !e.tagName
  }
), Ee = (e) => {
  const { tagName: n } = e;
  return n === "label" ? /* @__PURE__ */ a.createElement(
    t,
    {
      ...e,
      mruiClassName: "body",
      tagName: "label",
      inline: !e.tagName
    }
  ) : n === "span" ? /* @__PURE__ */ a.createElement(
    t,
    {
      ...e,
      mruiClassName: "body",
      tagName: "span",
      inline: !e.tagName
    }
  ) : /* @__PURE__ */ a.createElement(
    t,
    {
      ...e,
      mruiClassName: "body",
      tagName: "p",
      inline: !e.tagName
    }
  );
}, ke = (e) => {
  const { tagName: n } = e;
  return n === "label" ? /* @__PURE__ */ a.createElement(
    t,
    {
      ...e,
      mruiClassName: "body2",
      tagName: "label",
      inline: !e.tagName
    }
  ) : n === "span" ? /* @__PURE__ */ a.createElement(
    t,
    {
      ...e,
      mruiClassName: "body2",
      tagName: "span",
      inline: !e.tagName
    }
  ) : /* @__PURE__ */ a.createElement(
    t,
    {
      ...e,
      mruiClassName: "body2",
      tagName: "p",
      inline: !e.tagName
    }
  );
}, $e = (e) => {
  const { tagName: n } = e;
  return n === "label" ? /* @__PURE__ */ a.createElement(
    t,
    {
      ...e,
      mruiClassName: "body3",
      tagName: "label",
      inline: !e.tagName
    }
  ) : n === "span" ? /* @__PURE__ */ a.createElement(
    t,
    {
      ...e,
      mruiClassName: "body3",
      tagName: "span",
      inline: !e.tagName
    }
  ) : /* @__PURE__ */ a.createElement(
    t,
    {
      ...e,
      mruiClassName: "body3",
      tagName: "p",
      inline: !e.tagName
    }
  );
}, ve = (e) => /* @__PURE__ */ a.createElement(
  t,
  {
    ...e,
    mruiClassName: "button",
    tagName: e.tagName ?? "span",
    inline: !e.tagName
  }
), Le = (e) => /* @__PURE__ */ a.createElement(
  t,
  {
    ...e,
    mruiClassName: "link",
    tagName: e.tagName ?? "span",
    inline: !e.tagName
  }
), Be = (e) => /* @__PURE__ */ a.createElement(
  t,
  {
    ...e,
    mruiClassName: "legal",
    tagName: e.tagName ?? "small",
    inline: !e.tagName
  }
), He = (e) => /* @__PURE__ */ a.createElement(
  t,
  {
    ...e,
    mruiClassName: "ban1",
    tagName: e.tagName ?? "h1",
    inline: !e.tagName
  }
), Ae = (e) => /* @__PURE__ */ a.createElement(
  t,
  {
    ...e,
    mruiClassName: "ban2",
    tagName: e.tagName ?? "h2",
    inline: !e.tagName
  }
), De = (e) => /* @__PURE__ */ a.createElement(
  t,
  {
    ...e,
    mruiClassName: "breadcrumb",
    tagName: e.tagName ?? "span",
    inline: !e.tagName
  }
), Pe = (e) => /* @__PURE__ */ a.createElement(
  t,
  {
    ...e,
    mruiClassName: "data-header",
    tagName: e.tagName ?? "span",
    inline: !e.tagName
  }
), qe = (e) => /* @__PURE__ */ a.createElement(
  t,
  {
    ...e,
    mruiClassName: "data-cell",
    tagName: e.tagName ?? "span",
    inline: !e.tagName
  }
), we = (e) => /* @__PURE__ */ a.createElement(
  t,
  {
    ...e,
    mruiClassName: "data-annotation",
    tagName: e.tagName ?? "span",
    inline: !e.tagName
  }
), Se = (e) => /* @__PURE__ */ a.createElement(
  t,
  {
    ...e,
    mruiClassName: "data-pagination",
    tagName: e.tagName ?? "span",
    inline: !e.tagName
  }
), ze = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BAN1: He,
  BAN2: Ae,
  Body: Ee,
  Body2: ke,
  Body3: $e,
  Breadcrumb: De,
  Button: ve,
  DataAnnotation: we,
  DataCell: qe,
  DataHeader: Pe,
  DataPagination: Se,
  Heading1: he,
  Heading2: Te,
  Heading3: xe,
  Heading4: fe,
  Heading5: Ce,
  Heading6: ye,
  Legal: Be,
  Link: Le,
  TextComponent: t
}, Symbol.toStringTag, { value: "Module" })), { TextComponent: Qe, ...Ve } = ze;
export {
  Ve as T,
  Ne as c,
  c as d
};
